import { useState, useCallback } from 'react';

const STORAGE_KEY = 'favoriteCurrencies';

function loadFavorites(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveFavorites(favorites: string[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
}

export function useFavoriteCurrencies() {
  const [favorites, setFavorites] = useState<string[]>(loadFavorites);

  const toggleFavorite = useCallback((code: string) => {
    setFavorites(prev => {
      const next = prev.includes(code)
        ? prev.filter(c => c !== code)
        : [...prev, code];
      saveFavorites(next);
      return next;
    });
  }, []);

  const isFavorite = useCallback(
    (code: string) => favorites.includes(code),
    [favorites]
  );

  return { favorites, toggleFavorite, isFavorite };
}
